import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';

const FormikSubmitEffect = ({ onSubmitError, validationSchema }) => {
  const formik = useFormikContext();
  const { submitCount, isValid } = formik;
  const [lastHandled, setLastHandled] = useState(0);
  const { isSubmitting, isValidating, errors } = formik;
  useEffect(
    () => {
      const filteredArray = validationSchema
        ? Object.keys(errors).filter(value =>
            Object.keys(validationSchema.fields).includes(value)
          )
        : [];
      const isSchemaValid = validationSchema ? filteredArray.length > 0 : true;

      if (
        submitCount > lastHandled &&
        !isValid &&
        isSubmitting &&
        !isValidating &&
        isSchemaValid
      ) {
        onSubmitError(formik);
        setLastHandled(submitCount);
      }
      const keys = Object.keys(errors);

      if (keys.length > 0 && isSubmitting && !isValidating) {
        const selector = `[id="${keys[0]}"], [name="${keys[0]}"]`;
        const errorElement = document.querySelector(selector);
        if (errorElement) {
          setTimeout(
            () =>
              errorElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              }),
            200
          );
        }
      }
    },
    [
      submitCount,
      isValid,
      onSubmitError,
      lastHandled,
      formik,
      isSubmitting,
      isValidating,
      errors,
      validationSchema
    ]
  );
  return null;
};

export default FormikSubmitEffect;
